import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from "react-toastify";

const ToastProvider = () => (
  <ToastContainer closeButton={false} hideProgressBar position="bottom-right" />
);

export { ToastProvider };
